var ARROWS_TYPE = {
    DEFAULT_ARROW: 'DEFAULT_ARROW',
    ARROW_2: 'ARROW_2',
    ARROW_3: 'ARROW_3',
    ARROW_4: 'ARROW_4',
    ARROW_5: 'ARROW_5',
    ARROW_6: 'ARROW_6',
    ARROW_7: 'ARROW_7',
};
export default ARROWS_TYPE;
//# sourceMappingURL=layoutParams_navigationArrows_type.js.map